/**
 * A no-op function.
 */
export default () => {};
